// extracted by mini-css-extract-plugin
module.exports = {"root":"Messages_root__lOs_d","header":"Messages_header__26o7T"};